export enum CourseTimeType {
  None = 'None',
  Fixed = 'Fixed',
  NonFixed = 'NoneFixed',
  Reservation = 'Reservation'
}
